<small class="debug">{{me}}</small>
@if (m_appMode=='REMOTE_STATUS') {
  <div id="fqRemoteStatus" style="font-size: 1.7em; text-align: center">
    <h1>now serving {{m_currentlyServing}}</h1>
    <h1>you are {{m_fasterqLineModel.serviceId}} in line</h1>
    <h1>line name: {{m_fasterqLineModel?.lineName}}</h1>
    <h1>verification number {{m_fasterqLineModel?.verification}}</h1>
    <button mat-raised-button (click)="_releaseSpot()" id="fqReleaseSpot" style="float: right; width: 50%" class="tn btn-lg btn-primary">release number</button>
    <button mat-raised-button (click)="_getNewSpot()" id="fqGetNewNumber" style="float: right; width: 50%;" class="tn btn-lg btn-primary">renew number</button>
  </div>
}
@if (m_appMode=='CUSTOMER_TERMINAL') {
  <div id="fasterqCustomerTerminal">
    <div style="width: 100%">
      <h1 id="fqTakeNumberLineName" style="font-size: 10em; text-align: center" class="centerElement">{{m_fasterqLineModel?.lineName}}</h1>
    </div>
    <hr/>
    <h1 id="fasterQLineName"></h1>
    <hr/>
    <ngx-flicking
      [options]="{ circular: false, duration: 800, autoResize: true }"
      [plugins]="plugins">
      <div flicking-panel class="panel" >
        <div class="item active">
          <div style="width: 100%; text-align: center">
            <i style="font-size: 3em; padding-right: 40px" class=" fa fa-print"></i>
            <span style="font-size: 3em">Print your queue number</span>
            <br/>
            <button mat-raised-button color="warn" (click)="_onPrint($event)" class="fqPrintNumber">
              <span class="largeFont2em" data-localize="printIt">PRINT IT</span>
            </button>
            @if (m_printing) {
              <div #printArea>
                <h2 style="text-align: center" id="fqDisplayPrintNumber">Your line#: {{m_displayServiceId}}</h2>
                <h2 style="text-align: center"> Line name: {{m_lineName}}</h2>
              </div>
            }
          </div>
        </div>
      </div>
      <div flicking-panel class="panel">
        <div class="item">
          <div style="width: 100%; text-align: center">
            <i style="font-size: 3em; padding-right: 40px" class=" fa fa-qrcode"></i>
            <span data-localize="scanMobile" style="font-size: 3em">Scan with your mobile device</span>
            <div class="centerElement qrcode">
              <qrcode [qrdata]="qrValue" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode>
              @if (devMode) {
                <div>
                  <textarea>{{qrValue}}</textarea>
                </div>
              }
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
      </div>
      <div flicking-panel class="panel">
        <div class="item">
          <div style="width: 100%; text-align: center">
            <span style="font-size: 3em">Notify via email</span>
            <div style="padding-top: 50px">
              <input inputrestriction="basic1" [(ngModel)]="emailAddress" type="text" style="font-size: 3em; height: 2em" placeholder="enter email"/>
            </div>
            <button class="fqPrintNumber" color="warn" mat-raised-button (click)="_onSend($event)">
              <span class="largeFont2em">SEND IT</span>
            </button>
            <br/>
            <h1 id="fqDisplayEmailSent"></h1>
            <br/>
          </div>
        </div>
      </div>
      <div flicking-panel class="panel">
        <div class="item">
          <div style="width: 100%; text-align: center">
            <span style="font-size: 3em">Notify via text message</span>
            <div style="padding-top: 50px">
              <input inputrestriction="basic1" [(ngModel)]="sms" type="text" style="font-size: 3em; height: 2em" placeholder="enter phone"/>
            </div>
            <button class="fqPrintNumber" color="warn" mat-raised-button (click)="_onCall($event)">
              <span class="largeFont2em">CALL IT</span>
            </button>
            <br/>
            <h1 id="fqDisplaySMSSent"></h1>
            <br/>
          </div>
        </div>
      </div>
    </ngx-flicking>
    <div fxLayout="row" fxFill class="contButtons">
      <button fxFlex="100%" (click)="go('0')" class="goBack" mat-raised-button>
        <mat-icon>local_printshop</mat-icon>
        <span class="switchButtons ">print</span>
      </button>
      <button fxFlex="100%" (click)="go('1')" class="goBack" mat-raised-button>
        <mat-icon>qr_code</mat-icon>
        <span class="switchButtons ">scan</span>
      </button>
      <button fxFlex="100%" (click)="go('2')" class="goBack" mat-raised-button>
        <mat-icon>send</mat-icon>
        <span class="switchButtons ">email</span>
      </button>
      <button fxFlex="100%" (click)="go('3')" class="goBack" mat-raised-button>
        <mat-icon>chat</mat-icon>
        <span class="switchButtons ">text</span>
      </button>
    </div>
  </div>
}
